import React, {
    createContext,
    PropsWithChildren,
    useContext,
    useMemo,
    useState,
    useEffect,
} from "react";
import { Auth, Hub } from "aws-amplify";
// import { useContext, useEffect, useMemo, useState } from "react";
import { useQuery } from "react-query";
import { AwsConfigAuth } from "../utils/config/auth";

// 1. Create Context
const AuthContext = createContext(null);

// 2. Create custom hook
export const useAuthContext = () => {
    const context = useContext(AuthContext);
  
    if (!context) {
      throw new Error("useAuthContext must be used within an AuthProvider");
    }
    return context;
  };

export const AuthProvider = ({children}) => {
    const [user, setUser] = useState(null); // user normalized data
    const [userData, setUserData] = useState(null); // cognito user data
    const [isLogging, setIsLogging] = useState(false);
    const [isError, setIsError] = useState(false);

    // Get new token from service now using Cognito idToken
    const getUserToken = () => {
        const idToken = userData?.signInUserSession?.idToken?.jwtToken;
        /* return axiosInstance(
        "GET",
        null,
        null,
        null,
        null,
        "https://x281kdkxwd.execute-api.eu-west-1.amazonaws.com/v3_0_01/servicenow/oauth/token",
        "Bearer " + idToken
        ); */
        return idToken
    };

    const { isLoading: userLoading } = useQuery("getUserToken", getUserToken, {
        enabled: !!userData,
        refetchOnWindowFocus: false,
        refetchInterval: 240000, // update token every 4 min
        onSuccess: (data) => {
        localStorage.setItem("sessionToken", data ?? "");
        localStorage.setItem("refreshToken", data ?? "");
        },
    });

    const fetchUser = () => {
        /* const params = {
          sysparm_fields:
            "name,user_password,web_service_access_only,managed_domain,sys_domain,active,user_name,internal_integration_user,first_name,email,last_name,middle_name,preferred_language,sys_id",
          sys_id: userData?.sys_id,
          sysparm_display_value: true,
        };
    
        return axiosInstance("GET", query.path.user, null, params); */
        return {"username":"luisrodrigues", "password": 'SovfYb*xVqq4DcD"cSVP'}
    };

    const { isLoading: tokenLoading } = useQuery("getUser", fetchUser, {
        enabled: !!localStorage.getItem("sessionToken") && !!userData,
        refetchOnWindowFocus: false,
        onSuccess: (data) => {
          setUser(data );
        },
    });

    // Handle user authentication
    useEffect(() => {
      Hub.listen("auth", ({ payload: { event, data } }) => {
        setIsError(false);

        switch (event) {
            case "signIn":
            case "cognitoHostedUI":
                getUser().then((userData) =>
                    setUserData({
                    ...userData,
                    sys_id: userData?.attributes["custom:sys_id"],
                    })
                );
                break;
            case "signOut":
                setIsLogging(false);
                setUser(null);
                setUserData(null);
                Auth.signOut();
                break;
            case "signIn_failure":
            case "cognitoHostedUI_failure":
                setIsError(true);
                console.log("Sign in failure", data);
                break;
            default:
                console.log('Ups an error')
        }
      });

        getUser().then((userData) => {
        if (userData) {
            setUserData({
            ...userData,
            sys_id: userData?.attributes["custom:sys_id"],
            });
        }
        });
    }, []);

    // Get user from AWS-Cognito
    const getUser = () => {
        Auth.configure(AwsConfigAuth);

        return Auth.currentAuthenticatedUser()
        .then((userData) => userData)
        .catch(() => console.log("Not signed in"));
    };

    const login = async (use) => {
        Auth.configure(AwsConfigAuth);
    
        Auth.federatedSignIn({ customProvider: "NOVA-SAML" })
          .then((cred) => {
            // If success, you will get the AWS credentials
            console.log(cred);
            return Auth.currentAuthenticatedUser();
          })
          .then((user) => {
            // If success, the user object you passed in Auth.federatedSignIn
            console.log(user);
          })
          .catch((e) => {
            console.log(e);
          });
    
        await Auth.signIn(user.username, user.password);
      };

    const value = useMemo(() => {
    return {
        user,
        userData,
        login,
        // logout,
        isLogging: isLogging || tokenLoading || userLoading,
        isError,
    };
    }, [user, userData, isLogging, tokenLoading, userLoading, isError]);

    return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}